import { styled } from 'styled-components';

export const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
`;
